import { useState } from "react";
import { useAuth } from "@/lib/context";
import { useNavigate } from "react-router-dom";
import { Flame, Lock, User } from "lucide-react";

export default function Login() {
  const [username, setUsername] = useState("oim.admin");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr(null);
    try {
      await login(username, password);
      nav("/");
    } catch (ex) {
      setErr(ex.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="h-screen w-full flex items-center justify-center" style={{
      background: "radial-gradient(circle at 30% 30%, #1a0f0a 0%, #050507 60%)",
    }} data-testid="login-screen">
      <div className="absolute inset-0 opacity-30 pointer-events-none" style={{
        backgroundImage: "linear-gradient(rgba(255,153,0,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,153,0,0.04) 1px, transparent 1px)",
        backgroundSize: "32px 32px",
      }} />
      <div className="relative panel w-[420px] p-8" data-testid="login-card">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 bg-[#00E5FF] flex items-center justify-center">
            <Flame size={26} strokeWidth={2.2} color="#000" />
          </div>
          <div>
            <div className="font-display uppercase tracking-tight text-2xl font-bold">Ergoniq</div>
            <div className="font-display text-[11px] uppercase tracking-[0.2em] text-[#8F93A2]">OIM-Foundry · Energy Intelligence</div>
          </div>
        </div>
        <div className="label-small mb-2">F1 Pit Wall for the Foundry Floor</div>
        <div className="text-[#8F93A2] text-sm mb-6">
          Predict · Explain · Prescribe — every metric in rupees.
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="label-small flex items-center gap-2 mb-2"><User size={12} /> Username</label>
            <input className="input-field" value={username} onChange={(e) => setUsername(e.target.value)} data-testid="login-username" autoComplete="username" />
          </div>
          <div>
            <label className="label-small flex items-center gap-2 mb-2"><Lock size={12} /> Password</label>
            <input className="input-field" type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" autoComplete="current-password" />
          </div>
          {err && <div className="text-[#FF3333] text-sm font-mono" role="alert" data-testid="login-error">{err}</div>}
          <button type="submit" className="btn primary w-full" disabled={busy} data-testid="login-submit">
            {busy ? "Authenticating…" : "Enter Pit Wall"}
          </button>
        </form>

        <div className="mt-6 pt-4 border-t border-[#1F212A] text-[10px] text-[#8F93A2] font-mono">
          v1.0 · Saarv Solutions Private Limited · Confidential
        </div>
      </div>
    </div>
  );
}
